import {colors} from '@material-ui/core';

export interface Communication {
  __typename?: string,
  id: number
  ident?: string
  communication_type?: number
  title?: string
  body?: string
  active?: boolean
  receiver?: number
  log_code?: string
  mandatory?: boolean

  triggerValues?: CommunicationTriggerValue[]
}

export interface CommunicationTriggerValue {
  __typename?: string,
  id: number
  trigger_key: string
  trigger_value: string

  communication?: Communication
}

export const Receiver = {
    REPORTER: 0,
    TARGET: 1,
    ADMINS: 2,
    SUPER_ADMINS: 3,
    PAYLOAD_USER_IDS: 4,
    BILLING_PARTY_MEMBERS: 5,
    BILLING_PARTY_PAYING_MEMBERS: 7,
};

export const Receivers = [
    {name: 'reporter', colour: colors.grey[600]},
    {name: 'target', colour: colors.red[600]},
    {name: 'admins', colour: colors.orange[600]},
    {name: 'super admins', colour: colors.yellow[600]},
    {name: 'payload user ids', colour: colors.yellow[600]},
    {name: 'billing party members', colour: colors.green[600]},
    {name: 'user id and wcv accounting', colour: colors.green[600]},
    {name: 'billing party paying members', colour: colors.green[600]},
];

export const CommunicationType = {
    EMAIL: 0,
    SMS: 1,
    //ALERT: 2,
};

export const CommunicationTypes = [
    {name: 'email', colour: colors.grey[600]},
    {name: 'sms', colour: colors.grey[600]},
    //{name: 'alert', colour: colors.grey[600]},
];

export const WcvFromEmailAddresses = [
    'accounting@wcv.com',
    'dancetheworld@wcv.com',
    'broadway@wcv.com',
    'nashville@wcv.com',
    'holidayseason@wcv.com',
    'cook@wcv.com',
    'nycholidayseason@wcv.com',
];
